import { adjustHexTone, hexToRgbRaw } from "../../../utils";

export const limboSkinParser = (data) => {
  const {
    backgroundColor1,
    backgroundColor2,
    borderHighlightColor,
    buttonColor,
    footerIconColorActive,
    footerIconColorInactive,
    css,
    titleColor,
    textColor,
    winOddHistoryItemBgColor,
    winOddHistoryItemTextColor,
    loseOddHistoryItemBgColor,
    loseOddHistoryItemTextColor,
    formControlBackgroundColor,
  } = data;
  const { oddColor, oddColorWin, oddColorLose } = data;
  const parsedCss = ` 
    
    ${winOddHistoryItemBgColor ? `.odds-container{ .win { background-color: ${winOddHistoryItemBgColor}; }}` : ""}
    ${winOddHistoryItemTextColor ? `.odds-container{ .win { color: ${winOddHistoryItemTextColor}; }}` : ""}
    ${loseOddHistoryItemBgColor ? `.odds-container{ .lose { background-color: ${loseOddHistoryItemBgColor}; }}` : ""}
    ${loseOddHistoryItemTextColor ? `.odds-container{ .lose { color: ${loseOddHistoryItemTextColor}; }}` : ""}
    
    
    ${
      backgroundColor1
        ? `
    :root { --bg-deep: ${backgroundColor1}; --bg-app: ${backgroundColor1}; }
    .desktop-main-wrapper{background-color:${backgroundColor1} !important;} 
    .mobile-main-wrapper{background-color:${backgroundColor1} !important;} 
    .application-wrapper{background-color:${backgroundColor1} !important;} 
    `
        : ""
    }
    
    ${
      backgroundColor2
        ? `
    :root { --bg-surface: ${backgroundColor2}; --bg-card: ${adjustHexTone(backgroundColor2, 0.08)}; --bg-input: ${adjustHexTone(backgroundColor2, -0.06)}; --bg-elevated: ${adjustHexTone(backgroundColor2, 0.12)}; --border: ${adjustHexTone(backgroundColor2, 0.18)}; --border-light: ${adjustHexTone(backgroundColor2, 0.25)}; }
    .game-wrapper{background-color:${backgroundColor2} !important;}
    .balance-section-wrapper{background-color:${backgroundColor2} !important;}
    .betting-section-wrapper{background-color:${backgroundColor2} !important;}
    `
        : ""
    }
    
   ${
     textColor
       ? `
        p{color:${textColor};}
        .inner-title {color:${textColor};}
        .two-inner-title-wrappers { color:${textColor};}
        .switcher-title{ color:${textColor};}
        .bet-ui button { color:${textColor};}
        .bet-ui input { color:${textColor};}
        .bet-ui { color:${textColor};}
        .rows-risk-buttons-container { color:${textColor};}
        .auto-bet-counter-container button { color:${textColor};}
        .risk-btn{color:${textColor};}
        .auto-bet-counter-container input{color:${textColor};}
        .counter-wrapper input{color:${textColor};}
    `
       : ""
   }
    
    ${
      formControlBackgroundColor && textColor
        ? `
        .bet-ui { 
            color:${textColor};
            background:${formControlBackgroundColor};
        }
        .auto-bet-counter-container{
            background:${formControlBackgroundColor};
         }
        .win-chance-calculator-container{ background:${formControlBackgroundColor};}
        .auto-bet-counter-container button { color:${textColor};  background:${adjustHexTone(formControlBackgroundColor, -0.3)};}
        .auto-bet-counter-container button:hover { background:${adjustHexTone(formControlBackgroundColor, -0.35)};}
        .keyboard-wrapper{background:${formControlBackgroundColor};}
    `
        : ""
    }
    
    ${oddColor ? `.limbo-game-container .main-odd-text {color: ${oddColor};}` : ""}
    ${oddColorWin ? `.limbo-game-container .main-odd-text.win {color: ${oddColorWin};}` : ""}
    ${oddColorLose ? `.limbo-game-container .main-odd-text.lose {color: ${oddColorLose};}` : ""}
    
        ${
          titleColor
            ? `
        .modal-wrapper .header .title{color:${titleColor};}
        .title{color:${titleColor};}
        .game-title{color:${titleColor};}
    `
            : ""
        }
    
    ${
      borderHighlightColor
        ? `
    .auto-bet-counter-container:focus-within {border: 1px solid ${borderHighlightColor};}
    .bet-ui:focus-within {border: 1px solid ${borderHighlightColor};}
    `
        : ""
    }
    
    ${
      buttonColor
        ? `
    :root { --accent: ${buttonColor}; --accent-dim: ${adjustHexTone(buttonColor, -0.15)}; --accent-rgb: ${hexToRgbRaw(buttonColor)}; }
    .bet-button {background-image: linear-gradient(180deg, ${buttonColor}, ${buttonColor});}
    input:checked + .slider {background-color: ${buttonColor};}
    .button{background-image: linear-gradient(180deg, ${buttonColor}, ${buttonColor});}
    .keyboard-ok-btn{background-color: ${buttonColor};}
    `
        : ""
    }
    
    ${footerIconColorInactive ? `.icon {color:${footerIconColorInactive};}` : ""}
    ${footerIconColorActive ? `.icon.active {color:${footerIconColorActive};}` : ""}
    
    ${css ? css : ""}
    `;

  const skin = {
    logo: data.logo,
    css: parsedCss,
  };

  return skin;
};
